module.exports = __webpack_public_path__ + "static/img/dia-del-nino-4.315ae51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/dia-del-nino-4.jpg
// module id = c+53
// module chunks = 1